import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type CampaignProductsListRequest } from '../types/apiRequest'
import { type CampaignProductsListResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['campaignProductList'], CampaignProductsListResponse, CampaignProductsListRequest>({
  client: 'fortune',
  key: (params) => {
    const { campaign_code, ...restParams } = params || {}
    if (params?.campaign_code === undefined || params?.project_code === undefined) return undefined
    return `/campaigns/${campaign_code}/products/list?${queryStringify(restParams, {
      skipNull: true,
    })}`
  },
  isImmutable: true,
})

export const useApiCampaignProductsList = useRequest
